import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-grow max-w-7xl mx-auto py-24 px-4 sm:px-6 lg:px-8">
        {/* Company Introduction */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">About Us</h1>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Job Finding Strategies To Help Our Clients Become The #1 MUST Hire Candidate
          </p>
        </div>

        {/* Founder Section */}
        <div className="flex flex-col md:flex-row items-center gap-12 mt-12">
          <div className="w-full md:w-1/3">
            <div className="relative">
              <img 
                src="/images/headshot-mike.png" 
                alt="Mike Sudermann"
                className="w-64 h-64 rounded-full object-cover mx-auto"
              />
            </div>
            <h2 className="text-2xl font-bold text-center mt-4">Mike Sudermann</h2>
            <p className="text-gray-600 text-center">Founder</p>
          </div>

          <div className="w-full md:w-2/3 space-y-6">
            <p className="text-gray-700">
              Mike has been in talent aquisition for 20+ years. Mike and his team work with leaders who appreciate the value of hiring a strategic advisor whether for talent acquisition or simply for strategic insight to help their internal team hire better and faster.
            </p>

            <p className="text-gray-700">
              Mike has taken his decades of knowledge and with the power of AI made it accessible to everyone who wants an advantage in the job finding process.
            </p>

            <p className="text-gray-700">
              Additionally, Mike is a bestselling author of the book, The Executive Leap, Breakthrough Strategies to Land Your Next Top Job (all royalties are donated on Children's Adoption Services on behalf of his daughter Whitely who was adopted from Guatemala in 2007)
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs; 